import React, { useCallback, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AlertTriangle, ArrowRight } from 'lucide-react';
import api from '../lib/api';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';

/** Aviso diario de cobranza: visible en toda la Suite mientras haya mora. */
export function BillingBanner() {
  const { isAuthenticated, selectedChurchId } = useAuth();
  const location = useLocation();
  const [state, setState] = useState(null);

  const load = useCallback(() => {
    if (!isAuthenticated || !selectedChurchId) { setState(null); return; }
    api.get('/api/billing/state')
      .then(res => setState(res.data))
      .catch(() => setState(null));
  }, [isAuthenticated, selectedChurchId]);

  useEffect(() => { load(); }, [load]);

  if (!state?.days_overdue || location.pathname === '/billing') return null;

  const suspended = state.stage === 'suspendida' || state.stage === 'restringida';
  return (
    <div
      className={`px-4 sm:px-6 lg:px-8 py-2.5 flex items-center gap-3 flex-wrap text-sm border-b ${
        suspended
          ? 'bg-destructive/[0.08] border-destructive/20 text-destructive'
          : 'bg-[#C58B2A]/[0.08] border-[#C58B2A]/20 text-[#8a5f17]'
      }`}
      data-testid="billing-banner"
    >
      <AlertTriangle className="w-4 h-4 shrink-0" />
      <span>
        <strong>{state.days_overdue} día(s) de atraso</strong> en la suscripción
        ({state.amount_due?.toFixed(2)} USD).{' '}
        {state.stage === 'en_mora' && `La Suite se bloquea en ${state.suspends_in_days} día(s).`}
        {state.stage === 'suspendida' && 'La Suite está bloqueada para esta congregación.'}
        {state.stage === 'restringida' && 'El acceso de los miembros en la app está limitado.'}
      </span>
      <Button asChild size="sm" variant={suspended ? 'destructive' : 'outline'} className="ml-auto">
        <Link to="/billing" data-testid="billing-banner-cta">
          Pagar ahora <ArrowRight className="w-3.5 h-3.5 ml-1" />
        </Link>
      </Button>
    </div>
  );
}

export default BillingBanner;
